import * as types from '../mutation-types'

// state
export const state = {
  saved: []
}

// export const vuePersist = {
//   reducer: state => ({
//     saved: saved.lang,
//   }),
//   saveState: (key, state, storage) => {
//     requestIdleCallback(() => {
//       storage.setItem(key, JSON.stringify(state));
//     });
//   },
// };

// mutations
export const mutations = {
  toggleSaved (state, id) {
    const index = state.saved.findIndex(saved => saved === id)
    if (index === -1) {
      state.saved.push(id)
    } else {
      state.saved.splice(index, 1)
    }
  }
}

// actions

// // getters
// export const getters = {
//   responseMessage: state => {
//     return { ...state }
//   }
// }

export const getters = {
  fetchGemerkt: state => {
    return { ...state }
  },
  gemerktzahl: state => state.saved.length
}
